import React from 'react'
import { TextField as TF } from '@material-ui/core'
import { FieldError } from './FieldError'
import { Controller } from 'react-hook-form'
import './FormFields.css'

interface TextFieldProps {
  control: any
  label: string
  error: any
  name: string
  type?: string
  inputProps?: any
  autoComplete?: boolean
}

export const TextField: React.FC<TextFieldProps> = ({ control, label, name, error, type, inputProps, autoComplete = false }) => {
  const enableAutoComplete = autoComplete ? (e: any) => e : (e: any) => e.target.autocomplete = 'no'
  return (
    <>
      <Controller
        control={control}
        name={name}
        label={label}
        defaultValue=''
        render={(props) => <TF {...props} className='inputField' label={label} type={type} inputProps={{ ...inputProps, "aria-label": label }} onFocus={enableAutoComplete} />}
      />
      <FieldError fieldError={error} /> 
    </>
  )
}